import React from 'react';
import { SummaryLayout } from 'quanta-ui';
//import { Layout, ClientService } from '../../../../lib/layout/index';
import { Layout } from 'quanta-flows/modules/layout';
import { ClientService } from 'quanta-flows/modules/layout';
import SummaryPanel from './summary-panel';
import WizardPanel from './wizard-panel';
import { useParams } from 'react-router-dom';

export default function NewMotorPolicyIssuance({
  startStep,
  isProposalNumberGenerated,
  customerID,
  lobCode,
  lobName,
  productName,
  productCode,
  proposalNumber,
  stepsDisabled,
  breadcrumbNav,
  productType,
  ...props
}) {
 // console.log('SCPA two wheeler page calling')
  let nav = ['Quote', 'Buy Policy'];
  const params = useParams();
  const lob_code = params?.lob_code ? params?.lob_code : lobCode;
  const lob_name = params?.lob_name ? params?.lob_name : lobName;
  const product_code = params?.product_code
    ? params?.product_code
    : productCode;
  const product_name = params?.product_name
    ? params?.product_name
    : productName;
  const product_type = params?.product_type
    ? params?.product_type
    : productType;
//console.log('product_code',product_code)
    const planname = props?.planName ?
                    props?.planName
                    :params.planname
    const plancode = props?.planCode ?
                      props?.planCode
                      :params.planCode
  return (
    <Layout
      nav={breadcrumbNav ? breadcrumbNav : nav}
      service_type={ClientService}
      title={`Your ${product_name} Proposal`}
    >
      <SummaryLayout
        summary={
          <SummaryPanel
            {...{
              productName: product_name,
              productType: product_type,
              productCode: product_code,
              lobCode: lob_code,
              lobName: lob_name,
              planname,
              plancode
            }}
          />
        }
      >
        <WizardPanel
          {...{
            isProposalCreated: isProposalNumberGenerated,
            productName: product_name,
            productType: product_type,
            productCode: product_code,
            lobCode: lob_code,
            lobName: lob_name,
            startStep,
            proposalNumber,
            stepsDisabled,
            planname,
            plancode
          }}
        />
      </SummaryLayout>
      <div className="bg-neutral sticky bottom-0 p-3 -mx-4 mt-2 -mb-4 xl:hidden z-40">
        <SummaryPanel
          {...{
            productName: product_name,
            productType: product_type,
            productCode: product_code,
            lobCode: lob_code,
            lobName: lob_name,
            planname,
            plancode
          }}
        />
      </div>
    </Layout>
  );
}
